import React from 'react'
import FirebaseContext from "../../firebase/context";
import {
    Container,
    Paper,
    Grid,
    Typography,
    TextField,
    CardMedia,
    Card,
    CardContent,
    CardActions,
    Button,
} from "@material-ui/core";
import { Link, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CompExamenPreguntas from '../components/CompExamenPreguntas';
import CompAdminExamenItem from '../components/CompAdminExamenItem';
import CompExamenesItem from '../components/CompExamenesItem';
import UsuarioContext from '../contex/UsuarioContext';


const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
    },
}));


const style = {
    container: {
        width: '100%',
    },
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
    },
    paperMenu: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
    },
    link: {
        display: "flex"
    },
    gridTextfield: {
        marginTop: "20px"
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#B5DEF1",
    },
    cardMedia: {
        paddingTop: "56.25%"
    },
    cardContent: {
        flexGrow: 1
    },
    barraBoton: {
        marginTop: "20px"
    }
};

const PagExamenes = () => {
    const classes = useStyles();

    const { firebase, user } = React.useContext(FirebaseContext); 
    const [examenes, setExamenes] = React.useState([])

         ////////////////////////////////////////////////////////////////////  
        //  const usuarioContextLocal = React.useContext(UsuarioContext);
        //  const { setObjUsuario } = usuarioContextLocal;
         
        //  React.useEffect(() => {
        //      firebase.db.collection("colUsuarios").where("id", "==", user.uid).get().then(snapshot => {
        //          const arrayUsuario = snapshot.docs.map(doc => {
        //              let data = doc.data();
        //              let id = doc.id;
        //              return { id, ...data };
        //          });            
        //          setObjUsuario(arrayUsuario[0]);    
        //      });
        //  }, [])
     ///////////////////////////////////////////////////////////////////////////

    React.useEffect(() => {
        getExamenes();
    }, []);

    function getExamenes() {
       
        firebase.db.collection("colExamenes").get().then(snapshot => {
            const objExamenes = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setExamenes(objExamenes);
        });
    }

    return (

        <Container style={style.container}>
            <Grid container spacing={1}>

                <Grid item xs={12} sm={12} style={style.gridTextfield}>
                    <Paper style={style.paperMenu}>
                        {examenes.map((item, index) => (
                            <CompExamenesItem
                                key={index}
                                item={item}
                                index={index + 1}
                            />
                        ))}
                    </Paper>
                </Grid>              

            </Grid>
        </Container>
    )
}

export default PagExamenes
